import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import {
  Alert,
  Card,
  CardBody,
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  UncontrolledTooltip,
} from "reactstrap";

//import images
import wechat from "../../../assets/images/svg/river.svg";
import TableContainer from "Components/Common/TableContainer";
import { numberWithCommas } from "../../../helpers/globalHelper";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useCommonDataFindAllQuery, useRiverCreateMutation, useRiverDeleteMutation, useRiverFindAllQuery, useRiverUpdateMutation } from "store";
import DeleteModal from "Components/Common/DeleteModal";
import Switch from "react-switch";
import ShapeUpload from "Components/fileUpload/ShapeUpload";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import RiverSelectorMap from "Components/MainMap/RiverSelectorMap";

import voyager from '../../../assets/images/map/voyager.png';
import google from '../../../assets/images/map/google.jpg';
import topo from '../../../assets/images/map/topo.jpg';
import openstreet from '../../../assets/images/map/openstreet.jpg';
import AuInputList from "Components/Common/AuInputList";
import ImageUploader from "Components/fileUpload/ImageUploader";
import StatusSelect from "Components/Common/StatusSelect";

const Detail = ({ searchField }: any) => {
  const [baseMap, setBaseMap] = useState<'openstreet' | 'voyager' | 'google' | 'topo'>("voyager")
  const [selectedRiver, setSelectedRiver] = useState<any>();

  const [customQuery, setCustomQuery] = useState<any>();
  const [modal_backdrop, setmodal_backdrop] = useState(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isLoading, setLoading] = useState(true);

  const [riverOne, setRiverOne] = useState<any>();
  const [riverList, setRiverList] = useState<any>();
  const [riverCount, setRiverCount] = useState<any>();

  const [resetFiles, setResetFiles] = useState<boolean>(false);
  const [selectedFiles, setSelectedFiles] = useState<any>([]);

  // Datatable дээр pagination харуулахад хэрэгтэй
  const [customPagination, setCustomPagination] = useState<any>();
  const [customPageSize, setCustomPageSize] = useState<any>();
  const [customPageLength, setCustomPageLength] = useState<any>();

  const { data, error, isFetching } = useRiverFindAllQuery(customQuery);
  const [saveBorder, setSaveBorder] = useState<boolean>(false);

  const [riverUpdate, riverUpdateResult] = useRiverUpdateMutation();
  const [riverCreate, riverCreateResult] = useRiverCreateMutation();
  const [riverDelete, riverDeleteResult] = useRiverDeleteMutation();

  const {
    data: commonRiver,
    error: commonRiverError,
    isFetching: isCommonRiverFetching,
  } = useCommonDataFindAllQuery(`?group_name=cmd_river_type`);

  useEffect(() => {
    setRiverList(data?.data);
    setLoading(false);
    setRiverCount(riverList?.length);

    const tempSaveBorder = riverOne !== null ? riverOne?.save_border : false;
    setSaveBorder(tempSaveBorder)

    setCustomPagination(data?.pagination);
    const tempQuery = `?page=${customPageLength !== undefined ? customPageLength : 1
      }&pageSize=${customPageSize !== undefined ? customPageSize : 25}&${searchField !== undefined ? searchField : ''}`;
    setCustomQuery(tempQuery);
  }, [data, riverList, customPageSize, customPageLength, customPagination, searchField]);

  const toggle = useCallback(() => {
    if (modal_backdrop) {
      setmodal_backdrop(false);
      setRiverOne(null);
    } else {
      setmodal_backdrop(true);
    }
  }, [modal_backdrop]);

  const handleJobClick = useCallback((arg: any) => {
    const riverData = arg;
    setRiverOne({
      id: riverData.id,
      code: riverData.code,
      name: riverData.name,
      sea_level_m: riverData.sea_level_m,
      cmd_river_type: riverData.cmd_river_type,
      location: riverData?.location,
      save_border_desicion: riverData.save_border_desicion,

      basin_code: riverData.basin_code,
      au1_code: riverData.au1_code,
      au2_code: riverData.au2_code,
      au3_code: riverData.au3_code,

      longitude: riverData.longitude || null,
      latitude: riverData.latitude || null,

      status_id: riverData.status_id,
    });

    setSaveBorder(riverData?.save_border)

    setIsEdit(false);
    setIsEdit(true);
    toggle();
  }, []);

  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = (riverData) => {
    setRiverOne(riverData);
    setDeleteModal(true);
  };

  const handleDeletejob = () => {
    if (riverOne) {
      riverDelete(riverOne.id);
      setDeleteModal(false);
      setRiverOne(null);
      toastr.success("Мэдээлэл амжилттай устгагдлаа!", "Амжилттай");
    }
  };

  const columns = useMemo(
    () => [
      {
        header: "№",
        accessorKey: "id",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Код",
        accessorKey: "code",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Нэр",
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Голын төрөл",
        accessorKey: "river_type_name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "далайн түвшинээс дээш метр",
        accessorKey: "sea_level_m",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Хамгаалалтын бүстэй эсэх",
        enableColumnFilter: false,
        enableSorting: true,
        accessorKey: "save_border",
        cell: (cellProps: any) => {
          switch (cellProps.row.original.save_border) {
            case true:
              return (
                <span className="badge badge-soft-success fw-semibold fs-6 text">
                  Тийм
                </span>
              );
            default:
              return (
                <span className="badge badge-soft-warning fw-semibold fs-6 text">
                  Үгүй
                </span>
              );
          }
        },
      },
      {
        header: "Хамгаалалтын бүсийн шийдвэр",
        enableColumnFilter: false,
        enableSorting: true,
        accessorKey: "save_border_desicion",
      },

      {
        header: "Үйлдэл",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cellProps: any) => {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0">
              <li data-bs-toggle="tooltip" data-bs-placement="top" title="View">
                <Link to={`/surface/water/river/show/${cellProps.row.original.id}`} className="btn btn-sm btn-soft-primary">
                  <i className="mdi mdi-eye-outline" id="viewtooltip"></i>
                </Link>
                <UncontrolledTooltip placement="top" target="viewtooltip">
                  View
                </UncontrolledTooltip>
              </li>
              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-danger"
                  onClick={(event: any) => {
                    const riverData = cellProps.row.original;
                    event.preventDefault();
                    onClickDelete(riverData);
                  }}
                >
                  <i className="mdi mdi-delete-outline" id="deletetooltip" />
                  <UncontrolledTooltip placement="top" target="deletetooltip">
                    Устгах
                  </UncontrolledTooltip>
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-warning"
                  onClick={(event: any) => {
                    const riverData = cellProps.row.original;
                    event.preventDefault();
                    handleJobClick(riverData);
                  }}
                >
                  <i className="mdi mdi-pencil-outline" id="edittooltip" />
                  <UncontrolledTooltip placement="top" target="edittooltip">
                    Засах
                  </UncontrolledTooltip>
                </Link>
              </li>
            </ul>
          );
        },
      },
    ],
    []
  );

  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      code: riverOne?.code,
      name: riverOne?.name,
      cmd_river_type: riverOne?.cmd_river_type,
      location: riverOne?.location,
      save_border_desicion: riverOne?.save_border_desicion,
      sea_level_m: riverOne?.sea_level_m,

      basin_code: riverOne?.basin_code ?? null,
      au1_code: riverOne?.au1_code ?? null,
      au2_code: riverOne?.au2_code ?? null,
      au3_code: riverOne?.au3_code ?? null,
      longitude: riverOne?.longitude ?? null,
      latitude: riverOne?.latitude ?? null,
      status_id: riverOne?.status_id ?? null,
    },
    validationSchema: Yup.object({
      code: Yup.number().typeError("Тоон төрлийн утга оруулна уу!").required("Утга оруулна уу"),
      name: Yup.string().typeError("Текст төрлийн утга оруулна уу !").required("Утга оруулна уу"),
      location: Yup.string().typeError("Текст төрлийн оруулна уу !").required("Утга оруулна уу"),
      cmd_river_type: Yup.string().typeError("Утга сонгоно уу !").required("Утга оруулна уу"),
      save_border_desicion: Yup.string().typeError("Текст төрлийн утга оруулна уу !").required("Утга оруулна уу"),
      sea_level_m: Yup.number().typeError("Тоон төрлийн утга оруулна уу !").required("Утга оруулна уу"),
    }),
    onSubmit: (values: any) => {
      const formData = new FormData();
      if (isEdit) {
        formData.append('id', riverOne ? riverOne.id.toString() : '0');
        formData.append('code', values?.code);
        formData.append('name', values?.name);
        formData.append('cmd_river_type', values?.cmd_river_type);
        formData.append('location', values?.location);
        formData.append('save_border', String(saveBorder ?? false));
        formData.append('save_border_desicion', values?.save_border_desicion);
        formData.append('sea_level_m', values?.sea_level_m);

        formData.append('basin_code', values?.basin_code);
        formData.append('au1_code', values?.au1_code);
        formData.append('au2_code', values?.au2_code);
        formData.append('au3_code', values?.au3_code);
        formData.append('longitude', values?.longitude);
        formData.append('latitude', values?.latitude);
        formData.append('status_id', values?.status_id);

        if (selectedRiver) {
          formData.append('geom', JSON.stringify(selectedRiver.geometry))
        }

        riverUpdate(formData)
        toastr.success("Мэдээлэл амжилттай засагдлаа!", "Амжилттай");

      } else {
        formData.append('code', values?.code);
        formData.append('name', values?.name);
        formData.append('cmd_river_type', values?.cmd_river_type);
        formData.append('location', values?.location);
        formData.append('save_border', String(saveBorder ?? false));
        formData.append('save_border_desicion', values?.save_border_desicion);
        formData.append('sea_level_m', values?.sea_level_m);

        formData.append('basin_code', values?.basin_code);
        formData.append('au1_code', values?.au1_code);
        formData.append('au2_code', values?.au2_code);
        formData.append('au3_code', values?.au3_code);
        formData.append('longitude', values?.longitude);
        formData.append('latitude', values?.latitude);

        if (selectedRiver) {
          formData.append('geom', JSON.stringify(selectedRiver.geometry))
        }

        if (selectedFiles && selectedFiles.length > 0) {
          selectedFiles.forEach((file: File, index: number) => {
            formData.append(`shapes`, file);
          });
        }
        riverCreate(formData)
        toastr.success("Мэдээлэл амжилттай нэмэгдлээ!", "Амжилттай");
        setResetFiles(true);
      }
      validation.resetForm();
      setmodal_backdrop(false)
    },
  });

  const handleOnRiverSelected = ({ river, longitude, latitude }) => {
    setSelectedRiver(river);
    // const code = river?.id?.split('.')?.[1];
    // if (code) {
    //   validation.setFieldValue('code', code);
    // }
    validation.setFieldValue('name', riverOne?.name || river?.properties?.NameMon || "")

    validation.setFieldValue('latitude', latitude.toFixed(6));
    validation.setFieldValue('longitude', longitude.toFixed(6));
  };

  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Үгүй
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Тийм
      </div>
    );
  };


  return (
    <React.Fragment>
      <DeleteModal
        deleteName={riverOne?.name}
        show={deleteModal}
        onDeleteClick={handleDeletejob}
        onCloseClick={() => setDeleteModal(false)}
      />
      <Col xl={9}>
        <Card>
          <CardBody className="border-bottom">
            <div className="d-flex align-items-center">
              <img src={wechat} alt="" height="50" />
              <div className="flex-grow-1 ms-3">
                <h5 className="fw-semibold">Мэдээлэл</h5>
                <ul className="list-unstyled hstack gap-2 mb-0">
                  <li>
                    <i className="mdi mdi-table-row-height"></i>{" "}
                    <span className="text-muted fw-semibold">
                      Нийт: {numberWithCommas(riverCount)}{" "}
                    </span>
                  </li>
                </ul>
              </div>
              <button
                type="button"
                onClick={() => {
                  toggle();
                }}
                className="btn btn-success  btn-label"
              >
                <i className="mdi mdi-file-plus-outline label-icon"></i> Шинээр
                нэмэх
              </button>
            </div>
          </CardBody>

          <CardBody>
            <TableContainer
              setCustomPageSize={setCustomPageSize}
              setCustomPageLength={setCustomPageLength}
              customPagination={customPagination}
              columns={columns}
              data={riverList || ""}
              isCustomPageSize={true}
              isPagination={true}
              colWidth={2}
              SearchPlaceholder="Хэрэглэгч хайх . . ."
              tableClass="align-middle dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
              pagination="pagination"
              paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
            />
          </CardBody>
        </Card>
      </Col>

      <Modal
        size="xl"
        isOpen={modal_backdrop}
        toggle={() => {
          toggle();
        }}
        backdrop={"static"}
        id="staticBackdrop"
        centered
      >
        <ModalHeader
          toggle={() => {
            toggle();
          }}
        >
          <div className="h5 modal-title" id="staticBackdropLabel">
            {!!isEdit ? "Гол мэдээлэл засах" : "Гол мэдээлэл нэмэх"}
          </div>
        </ModalHeader>

        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <ModalBody>
            <Alert color="warning" className="mb-3">
              <strong className="text-danger">(*)</strong> тэмдэг бүхий талбарыг {""}
              <Link to="#" className="alert-link">
                заавал бөглөх
              </Link>  шаардлагатайг анхаарна уу !!!
            </Alert>
            <Row>
              <Col lg={6}>
                <div className="mb-3">
                  <Label> Голын бүртгэлийн дугаар *</Label>
                  <Input
                    name="code"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.code || ""}
                    invalid={
                      validation.touched.code &&
                        validation.errors.code
                        ? true
                        : false
                    }
                  />
                  {validation.touched.code &&
                    validation.errors.code ? (
                    <FormFeedback type="invalid">
                      {validation.errors.code}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label>Голын нэр  *</Label>
                  <Input
                    name="name"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.name || ""}
                    invalid={
                      validation.touched.name && validation.errors.name
                        ? true
                        : false
                    }
                  />
                  {validation.touched.name && validation.errors.name ? (
                    <FormFeedback type="invalid">
                      {validation.errors.name}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label>Далайн түвшинээс дээш метр *</Label>
                  <Input
                    name="sea_level_m"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.sea_level_m || ""}
                    invalid={
                      validation.touched.sea_level_m && validation.errors.sea_level_m
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.sea_level_m && validation.errors.sea_level_m ? (
                    <FormFeedback status="invalid">
                      {validation.errors.sea_level_m}
                    </FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label>Байршил *</Label>
                  <Input
                    name="location"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.location || ""}
                    invalid={
                      validation.touched.location && validation.errors.location
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.location && validation.errors.location ? (
                    <FormFeedback status="invalid">
                      {validation.errors.location}
                    </FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label >Солбицол Х</Label>
                  <Input
                    disabled
                    name="latitude"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.latitude || ""}
                    invalid={
                      validation.touched.latitude && validation.errors.latitude
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.latitude && validation.errors.latitude ? (
                    <FormFeedback status="invalid">
                      {validation.errors.latitude}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label >Солбицол У</Label>
                  <Input
                    disabled
                    name="longitude"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.longitude || ""}
                    invalid={
                      validation.touched.longitude && validation.errors.longitude
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.longitude && validation.errors.longitude ? (
                    <FormFeedback status="invalid">
                      {validation.errors.longitude}
                    </FormFeedback>
                  ) : null}
                </div>

                {!!isEdit &&
                  <StatusSelect
                    formik={validation}
                    name="status_id"
                  />
                }
              </Col>

              <Col lg={6}>
                <div className="mb-3">
                  <Label>	Голын төрөл *</Label>
                  <Input
                    name="cmd_river_type"
                    type="select"
                    className="form-select"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.cmd_river_type || ""}
                    invalid={
                      validation.touched.cmd_river_type &&
                        validation.errors.cmd_river_type
                        ? true
                        : false
                    }
                  >
                    <option disabled value="">Сонгох</option>
                    {commonRiver?.data?.map((item, index) => (
                      <option value={item?.id}>{item?.name}</option>
                    ))}

                  </Input>
                  {validation.touched.cmd_river_type &&
                    validation.errors.cmd_river_type ? (
                    <FormFeedback type="invalid">
                      {validation.errors.cmd_river_type}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label>Хамгаалалтын бүстэй эсэх*</Label> <br />
                  <Switch
                    uncheckedIcon={<Offsymbol />}
                    checkedIcon={<OnSymbol />}
                    className="me-1 mb-sm-8 mb-2 ms-3"
                    onColor="#626ed4"
                    onChange={() => {
                      setSaveBorder(!saveBorder);
                    }}
                    checked={saveBorder}
                  />
                </div>
                <div>
                  <Label>Хамгаалалтын бүсийн шийдвэр *</Label>
                  <Input
                    name="save_border_desicion"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.save_border_desicion || ""}
                    invalid={
                      validation.touched.save_border_desicion && validation.errors.save_border_desicion
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.save_border_desicion && validation.errors.save_border_desicion ? (
                    <FormFeedback status="invalid">
                      {validation.errors.save_border_desicion}
                    </FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <AuInputList
                    formik={validation}
                    showBasin
                    showAu1
                    showAu2
                    showAu3
                  />
                </div>

                {riverOne?.id &&
                  <div className="mb-3">
                    <Label>	Зураг оруулах </Label>
                    <ImageUploader
                      tableName="river"
                      connectionId={riverOne.id}
                      valueGroup="test"
                      accept={[".jpeg", ".jpg", ".png"]}
                      multiple
                    />
                  </div>
                }
              </Col>
            </Row>
            {!!isEdit ? '' :
              <Row>
                <ShapeUpload selectFiles={setSelectedFiles} onReset={resetFiles} fileType={"multipolygon"} />
              </Row>
            }
            <Row>
              <Col lg="12">
                <div className='mapTypeSelection'>
                  <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('voyager') }} src={voyager} alt="" />
                  <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('google') }} src={google} alt="" />
                  <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('topo') }} src={topo} alt="" />
                  <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('openstreet') }} src={openstreet} alt="" />
                </div>
                <RiverSelectorMap baseMap={baseMap} initialLongitude={riverOne?.longitude} initialLatitude={riverOne?.latitude} onRiverSelected={handleOnRiverSelected} />
              </Col>
            </Row>
          </ModalBody>

          <div className="modal-footer">
            <button type="button" className="btn btn-light" onClick={() => {
              setmodal_backdrop(false);
            }}>Хаах</button>
            <button type="submit" className="btn btn-primary"> Хадгалах </button>
          </div>
        </Form>
      </Modal>
    </React.Fragment>
  );
};

export default Detail;
